export default {
	paginate: function (array, page_size, page_number) {
		return array.slice(
			(page_number - 1) * page_size,
			page_number * page_size
		);
	},
	newId: function () {
		var id = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
			(
				c ^
				(crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
			).toString(16)
		);

		return id.replace(/-/g, "");
	},
	getTypeHtml: function (type, tag) {
		switch (type) {
			case "Fire Panel":
				return `<i class="type-icon fal fa-light fa-panel-fire" title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "TUNNEL SPRINKLER BST":
				return `<i class='type-icon fab fa-empire' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Gas Suppression System":
			case "Automatic Suppression System":
			case "Deluge Suppression System":
				return `<i class='type-icon fal fa-sprinkler' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Deluge Suppression Detection System":
				return `<i class='type-icon fal fa-sprinkler-ceiling' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Fire Door":
				return `<i class='type-icon fal fa-door-open' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Kolomela Fire Hydrant":
				return `<i class='type-icon fal fa-tint' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Other":
				return `<i class='type-icon fal fa-map-marker-question' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Fire Detection System":
				return `<i class='type-icon fal fa-thermometer-three-quarters' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Fire Hose":
				return `<i class='type-icon fal fa-tape' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Fire Hydrant":
				return `<i class='type-icon fal fa-tint' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Fire Hose Reel":
				return `<i class='type-icon fal fa-tape' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Fire Extinguisher":
			case "CO2 Fire Extinguisher":
			case "9kg Fire Extinguisher":
			case "4.5kg Fire Extinguisher":
			case "50l Foam Fire Extinguisher":
			case "50kg DCP Fire Extinguisher":
				return `<i class='type-icon fal fa-fire-extinguisher' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "First Aid Box":
				return `<i class='type-icon fal fa-medkit' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Vehicle Fire Suppression":
				return `<i class='type-icon fal fa-truck-monster' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Diesel Pump":
				return `<i class='type-icon fal fa-starship-freighter' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Water Pump":
				return `<i class='type-icon fal fa-starship-freighter' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Electric Pump":
				return `<i class='type-icon fal fa-starship-freighter' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Jockey Pump":
				return `<i class='type-icon fal fa-starship-freighter' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Conventional Fire Panel":
				return `<i class="type-icon fal fa-light fa-panel-fire" title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			case "Conveyor Belt Fire Control":
				return `<i class='type-icon fal fa-conveyor-belt' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
			default:
				return `<i class='type-icon fal fa-map-marker-question' title='${type}'></i><span class='tagnumber'>${tag}</span>`;
		}
	}
};
